import { Controller } from "@hotwired/stimulus"
import { showMyTourDisabledNotice } from "../lib/my_tour_disabled_notice"

export default class extends Controller {
  show(event) {
    showMyTourDisabledNotice(event)
  }
}
